import React from 'react'
import TablePagesControl from './table_pages.jsx';

export default class TableFooter extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <TablePagesControl getItemsFunction={this.props.getItemsFunction} itemsFilter={this.props.itemsFilter} />
            </div>
            )
    }
}